// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer___Rjgnr"};
    if(module.hot) {
      // 1720141051245
      var cssReload = require("/usr/local/youhuiquan/coupon-ui-frontend-umi/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  